<button
  type="button"
  class="g-btn"
  [class.g-btn--disabled]="loading"
  [disabled]="loading"
  [attr.aria-busy]="loading ? 'true' : null"
  (click)="onClick()">
  <svg class="g-btn__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path
      d="M19.6 10.23c0-.68-.06-1.36-.18-2.03H10v3.85h5.42a4.65 4.65 0 01-2.02 3.05v2.51h3.27c1.91-1.76 3-4.36 3-7.38z"
      fill="#4285F4" />
    <path
      d="M10 20c2.73 0 5.02-.9 6.69-2.45l-3.27-2.51c-.9.61-2.06.97-3.42.97-2.63 0-4.86-1.78-5.65-4.16H1.07v2.6A10 10 0 0010 20z"
      fill="#34A853" />
    <path d="M4.35 11.85a6 6 0 010-3.7V5.55H1.07a10 10 0 000 8.9l3.28-2.6z" fill="#FBBC04" />
    <path
      d="M10 3.95c1.48 0 2.81.51 3.86 1.51l2.89-2.89A10 10 0 001.07 5.55l3.28 2.6C5.14 5.74 7.37 3.95 10 3.95z"
      fill="#EA4335" />
  </svg>
  <span class="g-btn__label">{{ label }}</span>
</button>
